import { IconClose } from 'components/icons';
import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface Props {
  showing?: boolean;
  type?: 'question' | 'warning';
  title?: string;
  content?: string;
  cancelLable?: string;
  confirmLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
}

const ConfirmationModal = ({
  showing,
  type = 'question',
  title,
  content,
  cancelLable,
  confirmLabel,
  onConfirm,
  onCancel,
}: Props) => {
  const [isBrowser, setIsBrowser] = useState(false);
  const backgroundIcon = {
    question: 'bg-[url("/icons/question.svg")]',
    warning: 'bg-[url("/icons/information.svg")]',
  };

  useEffect(() => {
    setIsBrowser(true);
  }, []);
  useEffect(() => {
    if (!isEmpty(document.getElementById(`confirmation-modal`)?.children)) {
      document.body.style.overflow = 'hidden';
    }

    return () => {
      document.body.style.overflow = 'auto';
    };
  });

  return isBrowser && showing
    ? createPortal(
        <div className='fixed top-0 left-0 bottom-0 right-0 z-[175] flex items-center justify-center bg-[#000000]/[.3]'>
          <div className='flex w-[435px] max-w-[calc(100vw-24px)] flex-col items-center space-y-[16px] rounded-[8px] bg-paper p-[24px] drop-shadow-4'>
            <div className='flex w-full justify-end'>
              <button type='button' onClick={onCancel}>
                <IconClose className='min-h-[24px] min-w-[24px] text-stroke duration-[200ms] hover:text-text2' />
              </button>
            </div>
            <div className='flex h-[80px] w-[80px] items-center justify-center'>
              <div
                className={`h-[70px] w-[70px] ${backgroundIcon[type]} bg-cover bg-center bg-no-repeat`}
              />
            </div>
            <div className='flex w-full flex-col space-y-[16px]'>
              <div className='flex flex-col space-y-[12px] text-center'>
                <span className='text-[18px] font-[600] leading-[23px] text-primary line-clamp-[2]'>
                  {title}
                </span>
                <span className='text-[13px] leading-[21px] line-clamp-[10]'>{content}</span>
              </div>
              <div className='flex flex-col-reverse items-center space-y-[8px] space-y-reverse sm:flex-row sm:space-x-[8px] sm:space-y-0'>
                <button
                  type='button'
                  className='flex h-[40px] w-full overflow-hidden rounded-[8px] bg-tertiary px-[10px] transition duration-[200ms] ease-in-out hover:bg-tertiary-light'
                  onClick={onCancel}
                >
                  <span className='m-auto truncate font-[600]'>{cancelLable ?? 'Huỷ'}</span>
                </button>
                <button
                  type='button'
                  className='flex h-[40px] w-full overflow-hidden rounded-[8px] bg-primary px-[10px] transition duration-[200ms] ease-in-out hover:bg-primary-light'
                  onClick={onConfirm}
                >
                  <span className='m-auto truncate font-[600] text-paper'>
                    {confirmLabel ?? 'Xác nhận'}
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>,
        document.querySelector('#confirmation-modal')!,
      )
    : null;
};

export default ConfirmationModal;
